var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "collapse-text",
    _vm._b(
      { attrs: { value: _vm.displayText } },
      "collapse-text",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }